import styled from 'styled-components';

import * as Common from './components/Styles';
import * as MUI from '@mui/material';
import * as MUILabs from '@mui/lab';

const Theme = Common.Theme;

export const MUICustomTheme = MUI.createTheme({
	palette: {
		primary: { main: Theme.primary },
		secondary: { main: Theme.secondary },
		error: { main: Theme.error },
		success: { main: Theme.success },
		contrastText: Theme.white,
	},
	status: {
		danger: Theme.orange,
	},
	overrides: {
		MuiButton: {
			raisedPrimary: {
				color: Theme.white,
			},
		},
	},
});

export const RootContainer = styled.div`
	background-color: ${Theme.container};
	min-height: 100vh;
	align-items: flex-start;
	display: flex;
	overflow: unset;
`;

export const RootInnerContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
`;

export const Snackbar = styled(MUI.Snackbar)``;

export const Alert = styled(MUI.Alert)``;

export const AlertTitle = styled(MUI.AlertTitle)``;
